import { Button, Form, InputGroup, Modal, Table } from "react-bootstrap";
import { ServicioPagado } from "../../../types/ServicioPagado";
import { useCallback, useState } from "react";
import useFetch from "../../../hooks/useFetch";
import { toast } from "react-toastify";

interface Props {
  servicio: ServicioPagado | undefined;
  handleCloseModal: () => void;
  getPagos: () => void;
}

interface PagosForm {
  costo_servicio: number | undefined;
  costo_traslado: number | undefined;
}

const TicketPagoModal = ({ servicio, handleCloseModal, getPagos }: Props) => {
  const { sendRequest } = useFetch();
  const [pagos, setPagos] = useState<PagosForm>({
    costo_servicio: servicio?.pago.costo_servicio,
    costo_traslado: servicio?.pago.costo_traslado,
  });

  //Función que trata los servicios traidos de la BD.
  const transformData = useCallback(
    (variable: any) => {
      handleCloseModal();
      toast.success("Se ha actualizado el pago.", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      getPagos();
    },
    [handleCloseModal, getPagos]
  );

  const saveCambios = (): void => {
    sendRequest(
      {
        url: `/pago/${servicio?.pago.id}`,
        method: "PATCH",
        body: {
          ...pagos,
        },
      },
      transformData
    );
  };

  return (
    <Modal show={!!servicio} onHide={handleCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>Ticket de este servicio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {servicio?.pago.tipo_pago_id === 1 && (
          <Table responsive>
            <thead>
              <tr>
                <th>Costo del servicio</th>
                <th>Costo del traslado</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <InputGroup className="mb-3">
                    <InputGroup.Text id="basic-addon1">$</InputGroup.Text>
                    <Form.Control
                      defaultValue={servicio.pago.costo_servicio}
                      onChange={(e) =>
                        setPagos((prev: any) => {
                          return { ...prev, costo_servicio: e.target.value };
                        })
                      }
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup className="mb-3">
                    <InputGroup.Text id="basic-addon1">$</InputGroup.Text>
                    <Form.Control
                      defaultValue={servicio.pago.costo_traslado}
                      onChange={(e) =>
                        setPagos((prev: any) => {
                          return { ...prev, costo_traslado: e.target.value };
                        })
                      }
                    />
                  </InputGroup>
                </td>
              </tr>
            </tbody>
          </Table>
        )}
        {servicio?.pago.tipo_pago_id && servicio?.pago.tipo_pago_id > 1 && (
          <p>
            Este servicio no tiene pago:{" "}
            <strong>{servicio?.pago.tipo_pago.nombre}</strong>
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          style={{ float: "right" }}
          onClick={handleCloseModal}
        >
          Cerrar
        </Button>
        <Button
          style={{
            backgroundColor: "#21618C",
            borderColor: "white",
          }}
          disabled={
            !!servicio?.pago.tipo_pago_id && servicio?.pago.tipo_pago_id > 1
          }
          onClick={saveCambios}
        >
          Guardar cambios
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TicketPagoModal;
